import { render, staticRenderFns } from "./WaypointEditionView.vue?vue&type=template&id=58c2e5c5"
import script from "./WaypointEditionView.vue?vue&type=script&lang=js"
export * from "./WaypointEditionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports